import React, { useEffect } from "react";
import {publicRoutesPath } from '../Routes/index';
import { Redirect } from "react-router-dom";
import { useDispatch, useSelector } from "react-redux";
import { requestgetcurrenctuser } from "../Store/User/action";

const Authentication = props => {
    
    const dispatch = useDispatch();
    
    const token = localStorage.getItem('accessToken');


    useEffect(() => {
        dispatch(requestgetcurrenctuser(token));

    },[])

    if (token) {
        return props.children;
    } 
        
    return <Redirect to={publicRoutesPath.LOGIN} />;
    
   
   
};

export default Authentication;
